export const INPUT_CHANGED = 'INPUT_CHANGED'
export type INPUT_CHANGED = typeof INPUT_CHANGED

export const EXAMPLE_DATA_PICKED = 'EXAMPLE_DATA_PICKED'
export type EXAMPLE_DATA_PICKED = typeof EXAMPLE_DATA_PICKED

export const SEPARATOR_CHANGED = 'SEPARATOR_CHANGED'
export type SEPARATOR_CHANGED = typeof SEPARATOR_CHANGED

export const CUSTOM_SEPARATOR_CHANGED = 'CUSTOM_SEPARATOR_CHANGED'
export type CUSTOM_SEPARATOR_CHANGED = typeof CUSTOM_SEPARATOR_CHANGED

export const WRAPPER_CHANGED = 'WRAPPER_CHANGED'
export type WRAPPER_CHANGED = typeof WRAPPER_CHANGED

export const MERGE_REQUESTED = 'MERGE_REQUESTED'
export type MERGE_REQUESTED = typeof MERGE_REQUESTED

export const RESULT_CHANGED = 'RESULT_CHANGED'
export type RESULT_CHANGED = typeof RESULT_CHANGED

export const RESULTS_VISIBILITY_CHANGED = 'RESULTS_VISIBILITY_CHANGED'
export type RESULTS_VISIBILITY_CHANGED = typeof RESULTS_VISIBILITY_CHANGED

export const SCROLL_NOW_CHANGED = 'SCROLL_NOW_CHANGED'
export type SCROLL_NOW_CHANGED = typeof SCROLL_NOW_CHANGED

export interface IChangeInput {
  type: INPUT_CHANGED
  name: string
  value: string
}

export interface IExampleDataPicked {
  type: EXAMPLE_DATA_PICKED
  name: string
}

export interface ISeparatorChanged {
  type: SEPARATOR_CHANGED
  kind: string
}

export interface ICustomSeparatorChanged {
  type: CUSTOM_SEPARATOR_CHANGED
  value: string
}

export interface IWrapperChanged {
  type: WRAPPER_CHANGED
  kind: string
}

export interface IMergeRequested {
  type: MERGE_REQUESTED
}

export interface IResultChanged {
  type: RESULT_CHANGED
  result: string
}

export interface IResultsVisibilityChanged {
  type: RESULTS_VISIBILITY_CHANGED
  resultsAreVisible: boolean
}

export interface IScrollNowChanged {
  type: SCROLL_NOW_CHANGED
  scrollNow: boolean
}

export type Action =
  | IChangeInput
  | IExampleDataPicked
  | ISeparatorChanged
  | ICustomSeparatorChanged
  | IWrapperChanged
  | IMergeRequested
  | IResultChanged
  | IResultsVisibilityChanged
  | IScrollNowChanged

export const inputChanged = (name: string, value: string): IChangeInput => ({
  type: INPUT_CHANGED,
  name,
  value
})

export const exampleDataPicked = (name: string): IExampleDataPicked => ({
  type: EXAMPLE_DATA_PICKED,
  name
})

export const separatorChanged = (kind: string): ISeparatorChanged => ({
  type: SEPARATOR_CHANGED,
  kind
})

export const customSeparatorChanged = (
  value: string
): ICustomSeparatorChanged => ({
  type: CUSTOM_SEPARATOR_CHANGED,
  value
})

export const wrapperChanged = (kind: string): IWrapperChanged => ({
  type: WRAPPER_CHANGED,
  kind
})

export const mergeRequested = (): IMergeRequested => ({
  type: MERGE_REQUESTED
})

export const resultChanged = (result: string): IResultChanged => ({
  type: RESULT_CHANGED,
  result
})

export const resultsVisibilityChanged = (
  resultsAreVisible: boolean
): IResultsVisibilityChanged => ({
  type: RESULTS_VISIBILITY_CHANGED,
  resultsAreVisible
})

export const scrollNowChanged = (scrollNow: boolean): IScrollNowChanged => ({
  type: SCROLL_NOW_CHANGED,
  scrollNow
})
